var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 12 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7390_12076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.21632 2.16551C1.95632 4.40051 4.52882 7.70801 4.52882 7.70801V11.458C4.52882 12.283 5.20382 12.958 6.02882 12.958C6.85382 12.958 7.52882 12.283 7.52882 11.458V7.70801C7.52882 7.70801 10.1013 4.40051 11.8413 2.16551C12.2238 1.67051 11.8713 0.958008 11.2413 0.958008H0.80882C0.18632 0.958008 -0.16618 1.67051 0.21632 2.16551Z",
    fill: "#003DA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7390_12076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.958008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.7afb85be6cf2a4418e8e8e907f65dc16.svg";
export { ForwardRef as ReactComponent };